import React from 'react'
import PropTypes from 'prop-types'
import { BeAccountsApiContext } from '../contexts/BeAccountsApiContext'
import { withApi, extractData } from './ApiProvider'

export const withBeAccountsApi = ComponentToWrap => {
  const WrappedComponent = (props) => {
    return (
      <BeAccountsApiContext.Consumer>
        {value => (
          <ComponentToWrap {...props} beAccountsApi={value} />
        )}
      </BeAccountsApiContext.Consumer>
    )
  }

  WrappedComponent.displayName = `withBeAccountsApi(${ComponentToWrap.displayName || ComponentToWrap.name})`
  return WrappedComponent
}

const BeAccountsApiProviderComponent = (props) => {
  const { children, apiWrapper } = props

  const endpointsProvider = (baseURL) => {
    return {
      //  Account
      getAccount: `${baseURL}/api/account`,
      getAccountConfiguration: `${baseURL}/api/account/configuration`,
      getAccountDataRetention: () => `${baseURL}/api/account/dataretention`,
      //  User
      getUserById: (idUser) => `${baseURL}/api/user/${encodeURIComponent(idUser)}`,
      //  Options
      getOptionByShortName: (shortName) => `${baseURL}/api/option/${encodeURIComponent(shortName)}`
      //

    }
  }

  const endpoints = endpointsProvider(process.env.BEACCOUNTS_URL)

  const getAccount = (getAccount) => {
    const url = endpoints.getAccount

    return apiWrapper({
      method: 'get',
      url: url
    }).then(extractData)
  }

  const getAccountConfiguration = () => {
    const url = endpoints.getAccountConfiguration

    return apiWrapper({
      method: 'get',
      url: url
    }).then(extractData)
  }

  const getAccountDataRetention = () => {
    const url = endpoints.getAccountDataRetention()

    return apiWrapper({
      method: 'get',
      url: url
    }).then(extractData)
  }

  const getUserById = (idUser = 0) => {
    const url = endpoints.getUserById(idUser)

    return apiWrapper({
      method: 'get',
      url: url
    }).then(extractData)
  }

  const getOptionByShortName = (shortName) => {
    const url = endpoints.getOptionByShortName(shortName)

    return apiWrapper({
      method: 'get',
      url: url
    }).then(extractData)
  }

  const beAccountsApi = {
    getAccount,
    getAccountConfiguration,
    getUserById,
    getOptionByShortName,
    getAccountDataRetention
  }

  return (
    <BeAccountsApiContext.Provider value={beAccountsApi}>
      {children}
    </BeAccountsApiContext.Provider>
  )
}

BeAccountsApiProviderComponent.defaultProps = {
  children: null
}

BeAccountsApiProviderComponent.propTypes = {
  children: PropTypes.node,
  apiWrapper: PropTypes.func.isRequired
}

export const BeAccountsApiProvider = withApi(BeAccountsApiProviderComponent)
